/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_Feat3Inputs */

const en_fac_plan_feat3 = /** @type {(inputs: Fac_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cross-workspace facilitator dashboard`)
};

const id_fac_plan_feat3 = /** @type {(inputs: Fac_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard fasilitator lintas ruang kerja`)
};

/**
* | output |
* | --- |
* | "Cross-workspace facilitator dashboard" |
*
* @param {Fac_Plan_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_feat3 = /** @type {((inputs?: Fac_Plan_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_feat3(inputs)
	return en_fac_plan_feat3(inputs)
});